export const fr: Record<string, string> = {
  // Navbar
  'navbar.products': 'Produits',
  'navbar.useCases': "Cas d'usage",
  'navbar.pricing': 'Tarifs',
  'navbar.about': 'À propos',
  'navbar.contact': 'Contact',
  'navbar.bookDemo': 'Réserver une démo',
  'navbar.tripppMap': 'Trippp Map',
  'navbar.tripppSpark': 'Trippp Spark',
  'navbar.tripppTripOps': 'Trippp Ops',
  'navbar.dmosAndTourismBoards': 'OGD & Offices de tourisme',
  'navbar.dmcsAndTravelAgencies': 'DMC & Agences de voyage',
  'navbar.hotelsAndResorts': 'Hôtels & Resorts',
  'navbar.realEstateAndLifestyle': 'Immobilier & Lifestyle',

  // Hero
  'hero.title': 'Propulsez le voyage de bout en bout',
  'hero.subtitle':
    'La plateforme technologique modulaire pour le tourisme qui accompagne chaque étape, du premier désir au dernier jour sur le terrain.',
  'hero.bookDemo': 'Réserver une démo',
  'hero.exploreProducts': 'Découvrir les produits',

  // Social Proof
  'socialProof.trusted':
    'Des destinations et agences du monde entier nous font confiance',

  // Product Suite
  'productSuite.title': 'Une plateforme. Trois produits.',
  'productSuite.subtitle':
    'Une architecture modulaire conçue pour évoluer avec votre activité touristique.',
  'productSuite.learnMore': 'En savoir plus',
  'productSuite.mapName': 'Trippp Map',
  'productSuite.mapDesc':
    "Une carte interactive de destination en marque blanche. Points d'intérêt, itinéraires, sentiers de randonnée et contenu multilingue — le tout géré via un CMS dédié.",
  'productSuite.sparkName': 'Trippp Spark',
  'productSuite.sparkDesc':
    "Une expérience de découverte cinématographique basée sur l'émotion. Les voyageurs explorent une destination émotionnellement avant même de réserver un vol.",
  'productSuite.opsName': 'Trippp Ops',
  'productSuite.opsDesc':
    'Une application voyageur et une plateforme opérationnelle en un. En marque blanche par voyage, elle offre aux voyageurs leur programme complet tout en donnant aux agences une visibilité totale sur les extras et commissions.',

  // Persona Tabs
  'personaTabs.sectionTitle': 'Conçu pour votre secteur.',
  'personaTabs.tab0Label': 'OGD & Offices de tourisme',
  'personaTabs.tab1Label': 'DMC & Agences de voyage',
  'personaTabs.tab2Label': 'Hôtels & Resorts',
  'personaTabs.tab3Label': 'Promoteurs immobiliers & Lifestyle',
  'personaTabs.content0Title':
    'Mettez votre destination sur la carte numérique — littéralement.',
  'personaTabs.content0Desc':
    'Offrez aux visiteurs une fenêtre interactive et multilingue sur tout ce que votre région propose. Des sentiers cachés aux itinéraires sélectionnés, Trippp Map et Spark transforment toute destination en expérience numérique de classe mondiale — entièrement à votre marque.',
  'personaTabs.content0Feature0': 'Carte interactive de destination avec CMS',
  'personaTabs.content0Feature1': 'Expérience de découverte cinématographique',
  'personaTabs.content0Feature2':
    "Multilingue — propulsé par l'IA, toutes langues",
  'personaTabs.content1Title':
    'Des opérations plus efficaces. Plus de mandats internationaux.',
  'personaTabs.content1Desc':
    "Trippp Ops offre à votre agence une application voyageur en marque blanche pour chaque opération — marketplace d'extras, documents, programme, contacts d'urgence. Les partenaires internationaux vous choisissent parce que vous offrez une transparence fiable.",
  'personaTabs.content1Feature0':
    'Application voyageur en marque blanche par voyage',
  'personaTabs.content1Feature1': "Marketplace d'extras & commissions",
  'personaTabs.content1Feature2': 'Visibilité opérationnelle en temps réel',
  'personaTabs.content2Title':
    'Montrez à vos clients ce qui les entoure avant leur arrivée.',
  'personaTabs.content2Desc':
    "Intégrez Spark directement sur votre site web. Laissez vos futurs clients explorer votre établissement et la destination environnante à travers une expérience cinématographique qu'aucune galerie statique ne peut égaler.",
  'personaTabs.content2Feature0': 'Expérience cinématographique intégrable',
  'personaTabs.content2Feature1': 'Vitrine immobilière orientée destination',
  'personaTabs.content2Feature2': "Engagement immersif avant l'arrivée",
  'personaTabs.content3Title': 'Vendez le style de vie, pas seulement le bien.',
  'personaTabs.content3Desc':
    "Map et Spark offrent à vos acheteurs une vue immersive de la destination dans laquelle ils investissent — sentiers, restaurants, culture, expériences. L'environnement devient partie intégrante de l'argumentaire.",
  'personaTabs.content3Feature0': 'Cartographie immersive de destination',
  'personaTabs.content3Feature1': 'Expérience acheteur axée sur le lifestyle',
  'personaTabs.content3Feature2': "L'environnement comme argument de vente",

  // Use Cases
  'useCases.sectionTitle': 'Découvrez-le dans le monde réel.',
  'useCases.case0Label': 'Office de tourisme',
  'useCases.case0Title': 'Visit Beni Mellal-Khénifra',
  'useCases.case0Desc':
    "Un office de tourisme régional au Maroc a déployé Trippp Map et Spark pour numériser une destination jusqu'alors sous-promue — offrant aux visiteurs une fenêtre interactive et multilingue sur les montagnes, vallées et la culture de la région.",
  'useCases.case1Label': 'Office de tourisme',
  'useCases.case1Title': 'Visit Draa-Tafilalet',
  'useCases.case1Desc':
    "La porte d'entrée du Sahara au Maroc dispose désormais d'une carte interactive couvrant son vaste territoire — villes, oasis, kasbahs et itinéraires de trekking, le tout entièrement multilingue.",
  'useCases.case2Label': 'DMC',
  'useCases.case2Title': 'Lumi Morocco',
  'useCases.case2Desc':
    'Un DMC marocain a déployé Trippp Ops pour offrir aux voyageurs de ses clients internationaux une expérience de voyage entièrement brandée — programme, extras, documents et communication en temps réel, le tout sous la marque Lumi.',
  'useCases.explore': 'Explorer',
  'useCases.comingSoon': 'Bientôt disponible',

  // How It Works
  'howItWorks.title': 'Comment ça marche',
  'howItWorks.subtitle':
    'De la première conversation au déploiement complet en semaines, pas en mois.',
  'howItWorks.step0Title': 'Consulter',
  'howItWorks.step0Desc':
    'Nous analysons vos besoins opérationnels et objectifs uniques.',
  'howItWorks.step1Title': 'Configurer',
  'howItWorks.step1Desc':
    'Sélectionnez et personnalisez les modules adaptés à votre activité.',
  'howItWorks.step2Title': 'Déployer',
  'howItWorks.step2Desc':
    'Lancez votre plateforme brandée et commencez à scaler.',

  // Pricing Teaser
  'pricingTeaser.title': 'Tarification transparente. Sans surprises.',
  'pricingTeaser.desc':
    'Trippp est tarifé par produit, par déploiement. Licences annuelles, mise en place unique, et un modèle par opération pour Trippp Ops. Pas de frais cachés, pas de boîtes noires enterprise.',
  'pricingTeaser.cta': 'Voir tous les tarifs',

  // Final CTA
  'finalCTA.titlePart1': 'Une technologie touristique conçue pour ceux qui ',
  'finalCTA.titleHighlight': 'construisent la destination',
  'finalCTA.desc':
    "Pas adaptée d'un SaaS générique. Construite de zéro pour le fonctionnement réel du tourisme.",
  'finalCTA.cta': 'Réserver un appel de 30 minutes',

  // Footer
  'footer.tagline':
    'La plateforme technologique modulaire pour le tourisme qui propulse le voyage complet.',
  'footer.products': 'Produits',
  'footer.company': 'Entreprise',
  'footer.aboutUs': 'À propos',
  'footer.careers': 'Carrières',
  'footer.blog': 'Blog',
  'footer.contact': 'Contact',
  'footer.language': 'Langue',
  'footer.copyright': '© {year} Trippp Technologies. Tous droits réservés.',
  'footer.privacy': 'Politique de confidentialité',
  'footer.terms': "Conditions d'utilisation",

  // Pricing Page
  'pricing.heroTitle': 'Tarification transparente. ',
  'pricing.heroTitleHighlight': 'Sans surprises.',
  'pricing.heroDesc':
    'Chaque produit a une licence annuelle claire. Pas de frais cachés, pas de boîtes noires enterprise. Choisissez ce dont vous avez besoin, sachez ce que vous payez.',
  'pricing.mapTitle': 'Trippp Map',
  'pricing.mapSubtitle': 'Licence annuelle + mise en place unique',
  'pricing.sparkTitle': 'Trippp Spark',
  'pricing.sparkSubtitle': 'Licence annuelle + configuration unique',
  'pricing.opsTitle': 'Trippp Ops',
  'pricing.opsSubtitle': 'Deux options. Évoluez quand vous êtes prêt.',
  'pricing.tier': 'Niveau',
  'pricing.annualLicense': 'Licence annuelle',
  'pricing.setup': 'Mise en place (unique)',
  'pricing.city': 'Ville',
  'pricing.region': 'Région',
  'pricing.country': 'Pays / Multi-région',
  'pricing.hotelProperty': 'Hôtel / Propriété',
  'pricing.mapIncludes':
    "Inclut l'hébergement, l'accès CMS, l'API, les mises à jour de la plateforme et le support multilingue.",
  'pricing.dmoTourismBoard': 'OGD / Office de tourisme',
  'pricing.agency': 'Agence',
  'pricing.sparkIncludes':
    "Inclut l'hébergement, la configuration en marque blanche et les mises à jour de la plateforme.",
  'pricing.platformLicense': 'Licence plateforme',
  'pricing.perOperation': 'Par opération',
  'pricing.singleOperation': 'Opération unique',
  'pricing.noCommitment': 'Sans engagement',
  'pricing.oneTimeLabel': '(paiement unique)',
  'pricing.year': '/ an',
  'pricing.op': '/ op',
  'pricing.platformLicenseDesc':
    'Accès admin complet, CMS, kit de marque, comptes personnel illimités.',
  'pricing.perOperationDesc':
    "Linéaire. Pas de paliers. Pas d'engagements de volume. Chaque opération peut être en marque blanche indépendamment.",
  'pricing.singleOperationDesc':
    'Une opération, un prix. Pas de licence annuelle, sans engagement. Idéal pour un premier déploiement ou un voyage ponctuel.',
  'pricing.exampleNote':
    'Licence annuelle : une agence gérant 10 opérations/an paie 4 800 € + 5 000 € = 9 800 €. Ou essayez une opération unique pour 3 000 € sans engagement.',
  'pricing.bundleNote': "Vous utilisez plus d'un produit Trippp ? ",
  'pricing.bundleHighlight': 'Demandez-nous nos tarifs groupés.',
  'pricing.faqTitle': 'Questions fréquentes',
  'pricing.faq0Q': "Qu'est-ce qui est inclus dans la licence annuelle ?",
  'pricing.faq0A':
    'Hébergement, mises à jour de la plateforme, accès CMS, accès API, configuration en marque blanche et support multilingue. Tout ce dont vous avez besoin pour faire fonctionner le produit.',
  'pricing.faq1Q': 'Combien de temps prend le déploiement ?',
  'pricing.faq1A':
    'Généralement 2 à 4 semaines du lancement à la mise en ligne, selon la disponibilité du contenu et le périmètre.',
  'pricing.faq2Q':
    "Puis-je commencer avec un produit et en ajouter d'autres plus tard ?",
  'pricing.faq2A':
    'Oui. Chaque produit est indépendant. Ajoutez Map, Spark ou Trippp Ops quand vous êtes prêt.',
  'pricing.faq3Q': "Y a-t-il une période d'engagement ?",
  'pricing.faq3A':
    'Les licences sont annuelles. Aucun engagement pluriannuel requis.',
  'pricing.ctaTitle': 'Connaissez le prix. Voyez le produit. ',
  'pricing.ctaHighlight': 'Décidez en toute clarté.',
  'pricing.ctaCta': 'Réserver un appel de 30 minutes',

  // About Page
  'about.heroTitle': 'Nous construisons la technologie pour ceux qui ',
  'about.heroTitleHighlight': 'construisent les destinations.',
  'about.heroDesc':
    "Trippp est né de déploiements réels dans de vraies destinations. Pas d'un pitch deck — du terrain.",
  'about.originTitle': "D'où vient Trippp.",
  'about.originP1':
    "Trippp a commencé comme un ensemble d'outils construits pour des offices de tourisme qui avaient besoin d'une vraie infrastructure numérique — pas un autre site template, pas une autre brochure PDF.",
  'about.originP2':
    'Des cartes interactives, des expériences de découverte cinématographiques et des plateformes opérationnelles ont été conçues, déployées et testées en conditions réelles sur des destinations vivantes avant que Trippp ne devienne une entreprise produit.',
  'about.originP3':
    "Chaque fonctionnalité existe parce qu'un client en avait besoin dans le monde réel.",
  'about.beliefsTitle': 'Trois convictions qui nous guident.',
  'about.belief0Title': 'Conçu pour le tourisme, pas adapté.',
  'about.belief0Desc':
    'Les outils SaaS génériques forcent les professionnels du tourisme à adapter leur flux de travail. Trippp a été conçu dès le premier jour autour du fonctionnement réel des destinations, agences et hôtels.',
  'about.belief1Title': 'Modulaire par conception.',
  'about.belief1Desc':
    "Personne n'a besoin de tout dès le premier jour. Choisissez un produit, ajoutez-en d'autres quand c'est pertinent. Pas de bundles forcés, pas de packages surdimensionnés.",
  'about.belief2Title': 'Marque blanche par défaut.',
  'about.belief2Desc':
    'Votre marque, votre domaine, votre identité. Trippp disparaît derrière le nom que vous choisissez de mettre en avant.',
  'about.deployedTitle': 'Déployé. En ligne. Opérationnel.',
  'about.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'about.deployment0Desc':
    'Carte interactive régionale & découverte cinématographique.',
  'about.deployment1Title': 'Visit Draa-Tafilalet',
  'about.deployment1Desc':
    "Cartographie d'un vaste territoire, entièrement multilingue.",
  'about.deployment2Title': 'Lumi Morocco',
  'about.deployment2Desc':
    'Application voyageur en marque blanche et tableau de bord opérationnel.',
  'about.seeItLive': 'Voir en direct',
  'about.ctaTitle': 'Envie de voir ce que Trippp peut faire pour ',
  'about.ctaHighlight': 'votre destination ?',
  'about.ctaCta': 'Réserver un appel de 30 minutes',

  // Contact Page
  'contact.heroTitle': 'Parlons ',
  'contact.heroTitleHighlight': 'ensemble.',
  'contact.heroDesc':
    "Une question, un besoin spécifique, ou simplement envie d'en savoir plus ? Écrivez-nous directement.",
  'contact.nameLabel': 'Nom',
  'contact.namePlaceholder': 'Jean Dupont',
  'contact.emailLabel': 'Email',
  'contact.emailPlaceholder': 'jean@exemple.com',
  'contact.companyLabel': 'Entreprise',
  'contact.companyPlaceholder': "Nom de l'entreprise",
  'contact.roleLabel': 'Rôle',
  'contact.roleSelectRole': 'Sélectionner un rôle...',
  'contact.roleDmo': 'OGD & Office de tourisme',
  'contact.roleAgency': 'DMC & Agence de voyage',
  'contact.roleHotel': 'Hôtel & Resort',
  'contact.roleRealestate': 'Promoteur immobilier',
  'contact.roleOther': 'Autre',
  'contact.messageLabel': 'Message',
  'contact.messagePlaceholder': 'Comment pouvons-nous vous aider ?',
  'contact.sendMessage': 'Envoyer le message',
  'contact.responseTime': 'Nous répondons généralement sous 24 heures.',
  'contact.demoTitle': 'Vous préférez voir le produit en direct ?',
  'contact.demoDesc':
    'Pas de slides. Pas de pitch deck. Nous vous montrons le vrai produit sur de vraies destinations.',
  'contact.demoCta': 'Réserver un appel de 30 minutes →',
  'contact.faqTitle': 'Questions ',
  'contact.faqHighlight': 'fréquentes',
  'contact.faq0Q': 'Que se passe-t-il pendant la démo ?',
  'contact.faq0A':
    'Nous vous présentons le produit en direct — Map, Spark ou Trippp Ops selon vos besoins — fonctionnant sur de vrais déploiements de destinations. Pas de maquettes.',
  'contact.faq1Q': 'Dois-je préparer quelque chose ?',
  'contact.faq1A':
    'Non. Apportez simplement vos questions. Si vous souhaitez que nous nous concentrions sur un produit spécifique, mentionnez-le lors de la réservation.',
  'contact.faq2Q': 'Est-ce un appel commercial ?',
  'contact.faq2A':
    "C'est une présentation produit. Vous verrez exactement ce que vous obtiendriez. Les tarifs sont sur notre site — pas de surprises.",

  // Trippp Map Page
  'tripppMap.badge': 'Trippp Map',
  'tripppMap.heroTitle':
    "Chaque point d'intérêt. Chaque sentier. Chaque histoire. ",
  'tripppMap.heroTitleHighlight': 'Une seule carte.',
  'tripppMap.heroDesc':
    'Trippp Map est une carte interactive de destination en marque blanche, propulsée par un CMS dédié. Déployez-la pour une ville, une région ou un pays entier — entièrement brandée, multilingue et prête en quelques semaines.',
  'tripppMap.bookDemo': 'Réserver une démo',
  'tripppMap.seeItLive': 'Voir en direct',
  'tripppMap.featuresTitle':
    'Tout ce dont une destination a besoin en une seule plateforme.',
  'tripppMap.feature0Title': 'Carte interactive',
  'tripppMap.feature0Desc':
    "Une carte entièrement navigable avec un style personnalisé, des points d'intérêt filtrables et une expérience mobile fluide.",
  'tripppMap.feature1Title': 'Itinéraires sélectionnés',
  'tripppMap.feature1Desc':
    'Des parcours de voyage pré-construits qui guident les visiteurs à travers votre destination jour après jour.',
  'tripppMap.feature2Title': 'Module randonnée & sentiers',
  'tripppMap.feature2Desc':
    'Des sentiers GPS avec dénivelé, distance, difficulté et itinéraires téléchargeables.',
  'tripppMap.feature3Title': 'Contenu multilingue',
  'tripppMap.feature3Desc':
    "Chaque contenu traduisible dans la langue de votre audience — propulsé par l'IA.",
  'tripppMap.feature4Title': 'CMS dédié',
  'tripppMap.feature4Desc':
    'Un back-office conçu spécifiquement pour le tourisme — gérez lieux, tags, circuits, offres, articles et médias depuis un seul tableau de bord.',
  'tripppMap.feature5Title': 'Progressive Web App',
  'tripppMap.feature5Desc':
    "Installable sur tout téléphone. Fonctionne hors ligne. Envoie des notifications. Pas besoin d'app store.",
  'tripppMap.targetsTitle': 'Conçu pour des destinations de toute taille.',
  'tripppMap.target0Title': 'Ville',
  'tripppMap.target0Desc':
    'Une municipalité ou destination urbaine souhaitant numériser son expérience visiteur.',
  'tripppMap.target1Title': 'Région',
  'tripppMap.target1Desc':
    'Une province, gouvernorat ou territoire multi-villes avec des attractions diverses à organiser et promouvoir.',
  'tripppMap.target2Title': 'Pays',
  'tripppMap.target2Desc':
    'Un organisme national de tourisme déployant une carte numérique unifiée sur plusieurs régions.',
  'tripppMap.target3Title': 'Hôtel / Propriété',
  'tripppMap.target3Desc':
    'Un resort ou hôtel présentant les environs et les expériences locales disponibles pour les clients.',
  'tripppMap.deploymentsTitle': 'Trippp Map dans le monde réel.',
  'tripppMap.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'tripppMap.deployment0Desc':
    'Un office de tourisme régional au Maroc couvrant montagnes, cascades, vallées et villes historiques. Carte déployée avec CMS complet, contenu multilingue, itinéraires, sentiers de randonnée et offres sélectionnées.',
  'tripppMap.deployment1Title': 'Visit Draa-Tafilalet',
  'tripppMap.deployment1Desc':
    "La porte d'entrée du Sahara au Maroc. Carte interactive couvrant un vaste territoire d'oasis, kasbahs, routes désertiques et sentiers de trekking — le tout entièrement multilingue.",
  'tripppMap.exploreTheMap': 'Explorer la carte',
  'tripppMap.techTitle': 'Sous le capot.',
  'tripppMap.tech0':
    'Architecture API REST — chaque donnée accessible via des endpoints documentés',
  'tripppMap.tech1': 'Mapbox GL JS avec style cartographique personnalisé',
  'tripppMap.tech2': 'Médias hébergés sur AWS avec distribution CDN',
  'tripppMap.tech3': 'Contenu MongoDB avec synchronisation CMS en temps réel',
  'tripppMap.tech4': 'Documentation Swagger/OpenAPI incluse',
  'tripppMap.tech5': 'Marque blanche : votre domaine, votre logo, vos couleurs',
  'tripppMap.ctaTitle': 'Prêt à mettre votre destination ',
  'tripppMap.ctaHighlight': 'sur la carte ?',
  'tripppMap.ctaCta': 'Réserver un appel de 30 minutes',

  // Trippp Spark Page
  'tripppSpark.badge': 'Trippp Spark',
  'tripppSpark.heroTitle': 'Avant de chercher. Avant de réserver. ',
  'tripppSpark.heroTitleHighlight': 'Ils ressentent.',
  'tripppSpark.heroDesc':
    "Trippp Spark est une expérience de découverte cinématographique basée sur l'émotion. Les voyageurs ne filtrent pas par date ou prix — ils parcourent des histoires visuelles jusqu'à ce qu'une destination leur parle. Personnalisez-la à votre marque et intégrez-la partout.",
  'tripppSpark.bookDemo': 'Réserver une démo',
  'tripppSpark.experienceItLive': "Vivre l'expérience en direct",
  'tripppSpark.howItWorksTitle':
    "La découverte par l'émotion, pas la logistique.",
  'tripppSpark.step0Title': 'Ressentir',
  'tripppSpark.step0Desc':
    "Les visiteurs arrivent sur une expérience visuelle immersive en plein écran. Pas de menus. Pas de barres de recherche. Juste des images et de l'émotion.",
  'tripppSpark.step1Title': 'Explorer',
  'tripppSpark.step1Desc':
    "Ils glissent, défilent et tapent dans des catégories visuelles — aventure, sérénité, culture, vie nocturne — découvrant des lieux par ce qu'ils ressentent, pas par leur emplacement.",
  'tripppSpark.step2Title': 'Se connecter',
  'tripppSpark.step2Desc':
    "Chaque expérience renvoie vers du contenu détaillé — lieux, histoires, infos pratiques — reliant l'émotion à l'action.",
  'tripppSpark.targetsTitle':
    'Spark vit partout où les premières impressions comptent.',
  'tripppSpark.target0Title': 'OGD / Office de tourisme',
  'tripppSpark.target0Desc':
    "Déployez Spark comme la porte d'entrée émotionnelle de votre destination. Une expérience cinématographique complète couvrant tout ce que votre région offre, entièrement brandée.",
  'tripppSpark.target1Title': 'Hôtel / Resort',
  'tripppSpark.target1Desc':
    "Intégrez Spark sur votre site web. Laissez les clients potentiels ressentir l'établissement et ses environs avant même de vérifier la disponibilité.",
  'tripppSpark.target2Title': 'Agence',
  'tripppSpark.target2Desc':
    "Ajoutez Spark comme page d'expérience sur vos sites clients. Différenciez votre marque avec une couche de découverte qu'aucun concurrent ne possède.",
  'tripppSpark.deploymentTitle': 'Trippp Spark dans le monde réel.',
  'tripppSpark.deployment0Title':
    'Visit Beni Mellal-Khénifra — Mode Inspiration',
  'tripppSpark.deployment0Desc':
    "L'office de tourisme régional a déployé Spark aux côtés de Map pour créer une double expérience : les visiteurs peuvent explorer logiquement via Map ou émotionnellement via Spark. Les deux plateformes partagent la même API et le même contenu CMS.",
  'tripppSpark.experienceIt': "Vivre l'expérience",
  'tripppSpark.differentTitle':
    'Pas une galerie. Pas un slider. Un nouveau format.',
  'tripppSpark.diff0':
    "Plein écran, cinématographique d'abord. Conçu pour être ressenti, pas scanné.",
  'tripppSpark.diff1':
    'Contenu propulsé par le même CMS et API que Trippp Map. Une seule source de vérité.',
  'tripppSpark.diff2':
    'Marque blanche : votre marque, votre domaine, votre identité visuelle.',
  'tripppSpark.diff3':
    'Intégrable comme page autonome ou dans tout site web existant.',
  'tripppSpark.ctaTitle': 'Donnez à votre audience une raison de rêver ',
  'tripppSpark.ctaHighlight': 'avant de planifier.',
  'tripppSpark.ctaCta': 'Réserver un appel de 30 minutes',

  // Trippp Ops Page
  'tripppOps.badge': 'Trippp Ops',
  'tripppOps.heroTitle':
    "Une app pour le voyageur. Un tableau de bord pour l'agence. ",
  'tripppOps.heroTitleHighlight': 'Clarté totale pour tous.',
  'tripppOps.heroDesc':
    "Trippp Ops est une application voyageur et plateforme opérationnelle en marque blanche. Pour chaque opération, vos voyageurs obtiennent leur programme complet, marketplace d'extras, documents et contacts d'urgence. Votre équipe obtient la visibilité sur les réservations, le suivi des commissions et la messagerie broadcast. Brandé différemment pour chaque voyage si nécessaire.",
  'tripppOps.bookDemo': 'Réserver une démo',
  'tripppOps.seeHowItWorks': 'Voir comment ça marche',
  'tripppOps.travelerTitle': 'Ce que vos voyageurs voient.',
  'tripppOps.traveler0Title': 'Programme du voyage',
  'tripppOps.traveler0Desc':
    "Itinéraire jour par jour accessible via un code voyage unique. Aucun téléchargement d'app requis.",
  'tripppOps.traveler1Title': "Marketplace d'extras",
  'tripppOps.traveler1Desc':
    'Transferts, excursions, spa, restaurants — les voyageurs parcourent et réservent des services optionnels directement.',
  'tripppOps.traveler2Title': 'Bibliothèque de documents',
  'tripppOps.traveler2Desc':
    'Vouchers, billets, assurance voyage, infos pratiques — tout au même endroit.',
  'tripppOps.traveler3Title': "Contacts d'urgence",
  'tripppOps.traveler3Desc':
    "Numéros d'urgence locaux, contacts agence, infos hôtel — toujours accessibles.",
  'tripppOps.traveler4Title': 'Partage de médias',
  'tripppOps.traveler4Desc':
    'Photos et souvenirs partagés au sein du groupe de voyage.',
  'tripppOps.traveler5Title': 'Multilingue',
  'tripppOps.traveler5Desc':
    "Disponible dans toutes les langues — traduction propulsée par l'IA pour chaque audience.",
  'tripppOps.agencyTitle': 'Ce que votre équipe contrôle.',
  'tripppOps.agency0Title': 'Création de voyage',
  'tripppOps.agency0Desc':
    'Créez une nouvelle opération en quelques minutes. Définissez le programme, configurez les extras disponibles, assignez les participants.',
  'tripppOps.agency1Title': 'Marque blanche par opération',
  'tripppOps.agency1Desc':
    'Chaque voyage peut porter une marque différente — la vôtre, celle de votre partenaire ou celle de votre client. Logo, couleurs, domaine.',
  'tripppOps.agency2Title': 'Suivi des réservations & commissions',
  'tripppOps.agency2Desc':
    'Voyez chaque extra réservé, chaque service vendu. Suivez les commissions en temps réel sur toutes les opérations.',
  'tripppOps.agency3Title': 'Gestion des participants',
  'tripppOps.agency3Desc':
    "Ajoutez des voyageurs, gérez les accès, suivez l'engagement par opération.",
  'tripppOps.agency4Title': 'Messagerie broadcast',
  'tripppOps.agency4Desc':
    "Envoyez des mises à jour à tous les voyageurs d'une opération via notifications WhatsApp.",
  'tripppOps.mandatesTitle': "L'outil qui remporte les mandats.",
  'tripppOps.scenario0':
    "Une agence brésilienne mandate Trippp Ops à son prestataire DMC marocain. Chaque opération au Maroc passe par la plateforme — en marque blanche sous la marque de l'agence brésilienne. L'agence a une visibilité complète sur les extras vendus et les commissions gagnées, même à 10 000 km.",
  'tripppOps.scenario1':
    "Un DMC marocain propose à une agence internationale un voyage incentive de 200 personnes. Son différenciateur ? Une application voyageur brandée avec une marketplace de services complète, accès aux documents et mises à jour en temps réel. L'agence le choisit face à trois concurrents qui proposaient des tableurs et des PDF.",
  'tripppOps.deploymentTitle': 'Trippp Ops dans le monde réel.',
  'tripppOps.deployment0Title': 'Lumi Morocco',
  'tripppOps.deployment0Desc':
    "Un DMC marocain a déployé Trippp Ops pour servir ses clients agences internationaux. Les voyageurs accèdent à leur voyage complet sous la marque Lumi — programme, extras, documents, contacts d'urgence — tandis que l'équipe Lumi gère les réservations, suit les commissions et communique en temps réel.",
  'tripppOps.learnMore': 'En savoir plus',
  'tripppOps.pricingTitle': 'Tarification simple. Évolue avec vos opérations.',
  'tripppOps.platformLicense': 'Licence plateforme',
  'tripppOps.perOperation': 'Par opération',
  'tripppOps.noPriceNote':
    "Pas de frais cachés. Pas d'engagements de volume. Vous payez quand vous opérez.",
  'tripppOps.seeFullPricing': 'Voir tous les tarifs',
  'tripppOps.ctaTitle': 'Arrêtez de gérer vos voyages sur des tableurs. ',
  'tripppOps.ctaHighlight': 'Commencez à piloter vos opérations.',
  'tripppOps.ctaCta': 'Réserver un appel de 30 minutes',

  // Use Case DMO Page
  'useCaseDMO.badge': 'OGD & Offices de tourisme',
  'useCaseDMO.heroTitle': "Votre destination mérite mieux qu'un ",
  'useCaseDMO.heroTitleHighlight': 'site vitrine.',
  'useCaseDMO.heroDesc':
    'Trippp offre aux offices de tourisme une plateforme numérique modulaire : une carte interactive, une expérience de découverte cinématographique et un système de gestion de contenu complet — le tout en marque blanche, multilingue et déployable en quelques semaines.',
  'useCaseDMO.bookDemo': 'Réserver une démo',
  'useCaseDMO.challengeTitle': "Ce que les OGD affrontent aujourd'hui.",
  'useCaseDMO.pain0':
    "Des sites web statiques qu'aucun voyageur ne met en favori.",
  'useCaseDMO.pain1':
    'Du contenu dispersé entre PDF, réseaux sociaux et plateformes tierces que vous ne contrôlez pas.',
  'useCaseDMO.pain2':
    'Zéro infrastructure numérique pour rivaliser avec des destinations qui ont 10 fois votre budget.',
  'useCaseDMO.solutionTitle':
    "Map + Spark : l'ossature numérique de votre destination.",
  'useCaseDMO.mapDesc':
    'Offrez aux visiteurs une carte navigable, filtrable et multilingue de tout ce que votre région propose. Gérez tout le contenu via un CMS spécifique au tourisme — lieux, itinéraires, sentiers de randonnée, offres, articles.',
  'useCaseDMO.sparkDesc':
    "Créez une première impression émotionnelle. Une expérience cinématographique et swipeable qui fait ressentir votre destination aux voyageurs avant qu'ils ne planifient. Intégrable, brandable, partageable.",
  'useCaseDMO.sharedNote':
    '« Les deux produits partagent le même CMS et la même API. Un seul effort de contenu alimente deux expériences. »',
  'useCaseDMO.deploymentsTitle': 'Déploiements réels.',
  'useCaseDMO.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'useCaseDMO.deployment0Desc':
    "Un office de tourisme régional au Maroc a déployé Trippp Map et Spark pour numériser une destination jusqu'alors sous-promue — offrant aux visiteurs une fenêtre interactive et multilingue sur les montagnes, vallées et la culture de la région.",
  'useCaseDMO.deployment1Title': 'Visit Draa-Tafilalet',
  'useCaseDMO.deployment1Desc':
    "La porte d'entrée du Sahara au Maroc dispose désormais d'une carte interactive couvrant son vaste territoire — villes, oasis, kasbahs et itinéraires de trekking, le tout entièrement multilingue.",
  'useCaseDMO.seeItLive': 'Voir en direct',
  'useCaseDMO.whatYouGetTitle': 'Ce que vous obtenez.',
  'useCaseDMO.check0':
    'Plateforme en marque blanche sous votre marque de destination',
  'useCaseDMO.check1': 'CMS dédié conçu pour le contenu touristique',
  'useCaseDMO.check2': "Multilingue — toutes langues, propulsé par l'IA",
  'useCaseDMO.check3': 'API REST avec documentation publique',
  'useCaseDMO.check4':
    "PWA — installable, fonctionne hors ligne, pas d'app store",
  'useCaseDMO.check5':
    'Hébergement continu et mises à jour de la plateforme inclus',
  'useCaseDMO.ctaTitle': 'Mettez votre région sur la carte numérique. ',
  'useCaseDMO.ctaHighlight': 'Littéralement.',
  'useCaseDMO.ctaCta': 'Réserver un appel de 30 minutes',

  // Use Case DMC Page
  'useCaseDMC.badge': 'DMC & Agences de voyage',
  'useCaseDMC.heroTitle':
    'Gérez des opérations qui impressionnent vos clients et ',
  'useCaseDMC.heroTitleHighlight': 'sécurisez vos commissions.',
  'useCaseDMC.heroDesc':
    "Trippp Ops offre à votre agence une application voyageur en marque blanche et un tableau de bord opérationnel pour chaque voyage. Vos voyageurs bénéficient d'une expérience fluide pendant le voyage. Votre équipe a une visibilité complète sur les réservations, extras et commissions.",
  'useCaseDMC.bookDemo': 'Réserver une démo',
  'useCaseDMC.challengeTitle': "Ce que les DMC affrontent aujourd'hui.",
  'useCaseDMC.pain0':
    'Gérer la logistique des voyages entre groupes WhatsApp, emails et documents partagés.',
  'useCaseDMC.pain1':
    'Aucune visibilité sur les extras que les voyageurs achètent — et aucun moyen de capter les commissions.',
  'useCaseDMC.pain2':
    'Perdre des mandats internationaux face à des concurrents qui paraissent plus professionnels numériquement.',
  'useCaseDMC.solutionTitle':
    'Trippp Ops : une plateforme pour chaque opération.',
  'useCaseDMC.travelerAppTitle': "Fonctionnalités de l'app voyageur",
  'useCaseDMC.travelerFeature0': 'Programme & Itinéraire',
  'useCaseDMC.travelerFeature1': "Marketplace d'extras",
  'useCaseDMC.travelerFeature2': 'Bibliothèque de documents',
  'useCaseDMC.travelerFeature3': "Contacts d'urgence",
  'useCaseDMC.adminDashboardTitle': 'Fonctionnalités du tableau de bord admin',
  'useCaseDMC.adminFeature0': 'Création & gestion de voyages',
  'useCaseDMC.adminFeature1': 'Marque blanche par opération',
  'useCaseDMC.adminFeature2': 'Suivi des réservations & commissions',
  'useCaseDMC.adminFeature3': 'Messagerie broadcast',
  'useCaseDMC.whiteLabelNote':
    "« Chaque opération peut être en marque blanche sous une marque différente — la vôtre, celle de votre partenaire ou celle de l'agence de votre client. Même plateforme, visage différent. »",
  'useCaseDMC.edgeTitle':
    "Remportez les mandats. Gardez les commissions. Ayez l'air world-class.",
  'useCaseDMC.scenario0':
    "Une agence brésilienne mandate Trippp Ops à son prestataire DMC marocain. Chaque opération au Maroc passe par la plateforme — en marque blanche sous la marque de l'agence brésilienne. L'agence a une visibilité complète sur les extras vendus et les commissions gagnées, même à 10 000 km.",
  'useCaseDMC.scenario1':
    "Un DMC marocain propose à une agence internationale un voyage incentive de 200 personnes. Son différenciateur ? Une application voyageur brandée avec une marketplace de services complète, accès aux documents et mises à jour en temps réel. L'agence le choisit face à trois concurrents qui proposaient des tableurs et des PDF.",
  'useCaseDMC.deploymentTitle': 'Déploiement réel.',
  'useCaseDMC.deployment0Title': 'Lumi Morocco',
  'useCaseDMC.deployment0Desc':
    'Un DMC marocain a déployé Trippp Ops pour offrir aux voyageurs de ses clients internationaux une expérience de voyage entièrement brandée — programme, extras, documents et communication en temps réel, le tout sous la marque Lumi.',
  'useCaseDMC.learnMore': 'En savoir plus',
  'useCaseDMC.pricingTitle': 'Tarification simple. Évolue avec vos opérations.',
  'useCaseDMC.platformLicense': 'Licence plateforme',
  'useCaseDMC.perOperation': 'Par opération',
  'useCaseDMC.seeFullPricing': 'Voir tous les tarifs',
  'useCaseDMC.ctaTitle':
    'Votre prochain client choisit entre vous et un concurrent qui travaille sur tableur. ',
  'useCaseDMC.ctaHighlight': 'Rendez le choix évident.',
  'useCaseDMC.ctaCta': 'Réserver un appel de 30 minutes',

  // Use Case Hotels Page
  'useCaseHotels.badge': 'Hôtels & Resorts',
  'useCaseHotels.heroTitle': 'Vos clients veulent explorer. ',
  'useCaseHotels.heroTitleHighlight':
    'Donnez-leur une raison de commencer par vous.',
  'useCaseHotels.heroDesc':
    "Trippp offre aux hôtels et resorts deux outils pour enrichir l'expérience client : une carte interactive de la destination environnante et une expérience de découverte cinématographique — les deux intégrables sur votre site, les deux à votre marque.",
  'useCaseHotels.bookDemo': 'Réserver une démo',
  'useCaseHotels.challengeTitle': "Ce que les hôtels affrontent aujourd'hui.",
  'useCaseHotels.pain0':
    "Un beau site d'hôtel qui s'arrête au lobby. Rien sur ce qui vous entoure.",
  'useCaseHotels.pain1':
    'Les clients découvrent la destination sur TripAdvisor ou Google — pas à travers votre marque.',
  'useCaseHotels.pain2':
    "Aucun moyen de se différencier au-delà des photos de chambres et des listes d'équipements.",
  'useCaseHotels.solutionTitle': 'La solution Trippp.',
  'useCaseHotels.mapTitle': 'Trippp Map — Offre Propriété',
  'useCaseHotels.mapDesc':
    'Une carte interactive de vos environs. Restaurants, activités, sites culturels, plages, sentiers — sélectionnés par vous, présentés sous votre marque. Les clients explorent la destination à travers votre regard.',
  'useCaseHotels.sparkTitle': 'Trippp Spark — Offre Propriété',
  'useCaseHotels.sparkDesc':
    "Une page cinématographique sur votre site web qui permet aux futurs clients de ressentir la destination émotionnellement. Pas une galerie photo — une expérience de découverte plein écran, swipeable et basée sur l'émotion.",
  'useCaseHotels.fitsTitle': 'Intégré sans couture. Brandé complètement.',
  'useCaseHotels.fit0':
    "Spark devient une page sur votre site — « Explorer la destination » — qu'aucun hôtel concurrent ne possède.",
  'useCaseHotels.fit1':
    'Map vit comme un guide interactif que les clients peuvent consulter avant et pendant leur séjour.',
  'useCaseHotels.fit2':
    'Les deux portent le logo, les couleurs et le domaine de votre hôtel. Les visiteurs ne quittent jamais votre marque.',
  'useCaseHotels.ctaTitle': 'Arrêtez de vendre des chambres. ',
  'useCaseHotels.ctaHighlight':
    "Commencez à vendre l'expérience qui les entoure.",
  'useCaseHotels.ctaCta': 'Réserver un appel de 30 minutes',

  // Use Case Real Estate Page
  'useCaseRealEstate.badge': 'Immobilier & Lifestyle',
  'useCaseRealEstate.heroTitle': 'Vous ne vendez pas des mètres carrés. ',
  'useCaseRealEstate.heroTitleHighlight': 'Vous vendez un mode de vie.',
  'useCaseRealEstate.heroDesc':
    "Trippp offre aux promoteurs immobiliers et lifestyle des outils pour mettre en valeur la destination autour du bien — sentiers, restaurants, culture, expériences — transformant l'emplacement d'une simple ligne en attraction principale.",
  'useCaseRealEstate.bookDemo': 'Réserver une démo',
  'useCaseRealEstate.challengeTitle':
    "Ce que les promoteurs affrontent aujourd'hui.",
  'useCaseRealEstate.pain0':
    'Les acheteurs voient des plans et des rendus. Ils ne ressentent pas le style de vie.',
  'useCaseRealEstate.pain1':
    "L'emplacement est mentionné comme un point, jamais comme une expérience.",
  'useCaseRealEstate.pain2':
    'Les projets concurrents dans la même zone se ressemblent tous sur le papier.',
  'useCaseRealEstate.solutionTitle': 'La solution Trippp.',
  'useCaseRealEstate.mapDesc':
    'Une carte interactive des environs — restaurants, activités de plein air, sites culturels, écoles, transports. Les acheteurs potentiels explorent le quartier à travers un regard sélectionné et brandé.',
  'useCaseRealEstate.sparkDesc':
    'Une expérience cinématographique qui fait ressentir le style de vie aux acheteurs avant de visiter le showroom. Les sentiers de montagne au lever du soleil. Les restaurants côtiers au coucher du soleil. La scène culturelle le week-end.',
  'useCaseRealEstate.impactTitle':
    "Faites de l'environnement un argument de vente.",
  'useCaseRealEstate.impact0':
    'Quand deux projets offrent des specs similaires à des prix similaires, celui qui vend le style de vie gagne. Trippp rend le style de vie tangible.',
  'useCaseRealEstate.impact1':
    'Intégrez Map et Spark dans votre site de vente, vos brochures, vos écrans de showroom. Chaque point de contact devient un argument immersif.',
  'useCaseRealEstate.ctaTitle': 'Vendez la vue. Vendez le sentier. ',
  'useCaseRealEstate.ctaHighlight': 'Vendez le samedi matin.',
  'useCaseRealEstate.ctaCta': 'Réserver un appel de 30 minutes',
}
